import { render, staticRenderFns } from "./PartnerAgreement.vue?vue&type=template&id=4a74e580&scoped=true&"
import script from "./PartnerAgreement.vue?vue&type=script&lang=js&"
export * from "./PartnerAgreement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a74e580",
  null
  
)

export default component.exports